import './BuyerSubTabs.scss';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

interface BuyerLike {
    buyerId: number;
    buyerName: string;
    isSelected?: boolean;
}

interface BuyerTab {
    id: 'summary' | number;
    label: string;
    isSelected?: boolean;
}

export function useBuyerSubTabs<T extends BuyerLike>(items: T[]) {
    const [searchParams, setSearchParams] = useSearchParams();

    const buyerTabParam = searchParams.get('buyertab');
    const buyerTabParamId = Number(buyerTabParam);
    const activeBuyerTab: 'summary' | number =
        buyerTabParam && buyerTabParamId && items.some((item) => item.buyerId === buyerTabParamId)
            ? buyerTabParamId
            : 'summary';

    const orderedItems = [...items].sort((a, b) =>
        a.buyerName.localeCompare(b.buyerName)
    );
    const buyerTabs: BuyerTab[] = [
        { id: 'summary', label: 'Summary' },
        ...orderedItems.map((item) => ({ id: item.buyerId, label: item.buyerName, isSelected: item.isSelected })),
    ];

    const visibleItems =
        activeBuyerTab === 'summary'
            ? items
            : items.filter((item) => item.buyerId === activeBuyerTab);

    const changeBuyerTab = (tabId: 'summary' | number) => {
        const params = new URLSearchParams(searchParams);
        if (tabId === 'summary') {
            params.delete('buyertab');
        } else {
            params.set('buyertab', String(tabId));
        }
        setSearchParams(params);
    };

    return { activeBuyerTab, buyerTabs, visibleItems, changeBuyerTab };
}

interface BuyerSubTabsProps {
    buyerTabs: BuyerTab[];
    activeBuyerTab: 'summary' | number;
    onChange: (tabId: 'summary' | number) => void;
}

export const BuyerSubTabs = ({ buyerTabs, activeBuyerTab, onChange }: BuyerSubTabsProps) => {
    return (
        <div className="RRT__container loi-buyer-subtabs">
            <div className="RRT__tabs body-tabs">
                {buyerTabs.map((tab) => (
                    <div
                        key={tab.id}
                        className={
                            activeBuyerTab === tab.id
                                ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                : 'RRT__tab'
                        }
                        onClick={() => onChange(tab.id)}>
                        {tab.label}
                        {tab.isSelected && (
                            <span className="loi-buyer-subtabs-selected-badge" aria-label="Selected LOI">✓</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
